export const bridgeKeys = {
  becon_ios: "becon_ios",
  becon_android: "becon_android",
  appInfo: "appInfo",
  deviceInfo: "deviceInfo",
  fcmTokenInfo: "fcmTokenInfo",
  wifiDirectInfo: "wifiDirectInfo",
  onUserInactivity: "onUserInactivity",
} as const;
